import initializeInboxRulesEditState from '../actions/helpers/initializeInboxRulesEditState';
import { map } from 'mobx';
import { createStore } from 'satcheljs';
export default createStore('inboxRulesOption', {
    inboxRulesListState: {
        inboxRules: map({}),
        inboxRuleIds: [],
        getInboxRuleRequestStatus: 0 /* NotInitiated */,
        getInboxRuleDiagnosticRequestStatus: 0 /* NotInitiated */,
        hasLoggedGetInboxRulesInformation: false,
    },
    inboxRulesEditState: initializeInboxRulesEditState(),
    findFoldersRequestStatus: 0 /* NotInitiated */,
    contextMenuFolders: [],
    junkFolderDisplayName: '',
})();
//# sourceMappingURL=store.js.map